const FORMSUBMIT_URL = 'https://formsubmit.co/ajax/viczerga@gmail.com'

interface FormPayload {
  subject: string
  [key: string]: string | number | boolean | undefined
}

export async function sendFormEmail(data: FormPayload): Promise<boolean> {
  try {
    const res = await fetch(FORMSUBMIT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        ...data,
        _captcha: false,
        _template: 'table',
      }),
    })
    const result = await res.json()
    return result.success === 'true' || result.success === true
  } catch (err) {
    console.error('Form submission error:', err)
    return false
  }
}
